import { DeviceIconState } from 'console/device/icon/types';
export const device_state_filter_color = {
    [DeviceIconState.no_service]: '#8a8a8a',
    [DeviceIconState.not_on_operation]: '#f05b5b',
    [DeviceIconState.malfunction]: '#c98b2e',
    [DeviceIconState.guard_zone_alarm]: '#c98b2e',
    [DeviceIconState.sensor_alarm]: '#c98b2e',
    [DeviceIconState.alarm]: '#f05b5b',
    [DeviceIconState.offline]: '#f05b5b',
    [DeviceIconState.offline_ride]: '#f05b5b',
    [DeviceIconState.offline_parking]: '#f05b5b',
    [DeviceIconState.online]: '#32a852',
    [DeviceIconState.online_ride]: '#32a852',
    [DeviceIconState.online_parking]: '#188dc7',
    [DeviceIconState.guard_on]: '#8a8a8a',
    [DeviceIconState.guard_enabling]: '#8a8a8a',
    [DeviceIconState.guard_off]: '#8a8a8a',
    [DeviceIconState.guard_off_silent]: '#8a8a8a',
};
export const translate_device_icon_state = {
    [DeviceIconState.no_service]: 'Не на обслуживании',
    [DeviceIconState.not_on_operation]: 'Не в эксплуатации',
    [DeviceIconState.malfunction]: 'Неисправность прибора',
    [DeviceIconState.offline]: 'Не на связи',
    [DeviceIconState.alarm]: 'Авария',
    [DeviceIconState.guard_zone_alarm]: 'Сработка охраны',
    [DeviceIconState.offline_ride]: 'Не на связи, двигался',
    [DeviceIconState.offline_parking]: 'Не на связи, парковка',
    [DeviceIconState.online]: 'На связи',
    [DeviceIconState.online_ride]: 'На связи, движется',
    [DeviceIconState.online_parking]: 'На связи, стоит',
    [DeviceIconState.guard_on]: 'Под охраной',
    [DeviceIconState.guard_enabling]: 'Постановка под охрану с задержкой',
    [DeviceIconState.guard_off]: 'Снято с охраны',
    [DeviceIconState.guard_off_silent]: 'Снято с охраны',
    [DeviceIconState.sensor_alarm]: 'Сработка датчика',
};
export const autoscan_devices_all_state_filters = [
    {
        state: DeviceIconState.no_service,
        text: translate_device_icon_state[DeviceIconState.no_service],
    },
    {
        state: DeviceIconState.not_on_operation,
        text: translate_device_icon_state[DeviceIconState.not_on_operation],
    },
    {
        state: DeviceIconState.malfunction,
        text: translate_device_icon_state[DeviceIconState.malfunction],
    },
    {
        state: DeviceIconState.offline,
        text: translate_device_icon_state[DeviceIconState.offline],
    },
    {
        state: DeviceIconState.offline_ride,
        text: translate_device_icon_state[DeviceIconState.offline_ride],
    },
    {
        state: DeviceIconState.offline_parking,
        text: translate_device_icon_state[DeviceIconState.offline_parking],
    },
    {
        state: DeviceIconState.online,
        text: translate_device_icon_state[DeviceIconState.online],
    },
    {
        state: DeviceIconState.online_ride,
        text: translate_device_icon_state[DeviceIconState.online_ride],
    },
    {
        state: DeviceIconState.online_parking,
        text: translate_device_icon_state[DeviceIconState.online_parking],
    },
    {
        state: DeviceIconState.guard_on,
        text: translate_device_icon_state[DeviceIconState.guard_on],
    },
    {
        state: DeviceIconState.guard_off,
        text: translate_device_icon_state[DeviceIconState.guard_off],
    },
];
export const zontnext_devices_all_state_filters = [
    {
        state: DeviceIconState.alarm,
        text: translate_device_icon_state[DeviceIconState.alarm],
    },
    {
        state: DeviceIconState.offline,
        text: translate_device_icon_state[DeviceIconState.offline],
    },
    {
        state: DeviceIconState.guard_zone_alarm,
        text: translate_device_icon_state[DeviceIconState.guard_zone_alarm],
    },
    {
        state: DeviceIconState.sensor_alarm,
        text: translate_device_icon_state[DeviceIconState.sensor_alarm],
    },
    {
        state: DeviceIconState.online,
        text: translate_device_icon_state[DeviceIconState.online],
    },
    {
        state: DeviceIconState.guard_on,
        text: translate_device_icon_state[DeviceIconState.guard_on],
    },
    {
        state: DeviceIconState.guard_off,
        text: translate_device_icon_state[DeviceIconState.guard_off],
    },
];
export const z3k_devices_all_state_filters = [
    {
        state: DeviceIconState.offline,
        text: translate_device_icon_state[DeviceIconState.offline],
    },
    {
        state: DeviceIconState.online,
        text: translate_device_icon_state[DeviceIconState.online],
    },
    {
        state: DeviceIconState.guard_on,
        text: translate_device_icon_state[DeviceIconState.guard_on],
    },
    {
        state: DeviceIconState.guard_off,
        text: translate_device_icon_state[DeviceIconState.guard_off],
    },
];
export const translate_device_icon_state_emoji = {
    [DeviceIconState.no_service]: '🚫',
    [DeviceIconState.not_on_operation]: '❌ ',
    [DeviceIconState.malfunction]: '⚠️',
    [DeviceIconState.offline]: '️⭕',
    [DeviceIconState.offline_ride]: '⭕️ ▶',
    [DeviceIconState.offline_parking]: '⭕️ 🅿️',
    [DeviceIconState.online]: '🟢',
    [DeviceIconState.online_ride]: '🟢  ▶',
    [DeviceIconState.online_parking]: '🟢  🅿️',
    [DeviceIconState.guard_on]: '🔒',
    [DeviceIconState.guard_enabling]: '🔒  ⏳',
    [DeviceIconState.guard_off]: '🔓',
    [DeviceIconState.guard_off_silent]: '🔓',
    [DeviceIconState.guard_zone_alarm]: '🔓',
    [DeviceIconState.alarm]: '',
    [DeviceIconState.sensor_alarm]: '',
};
export const alarm_device_icon_states = [
    DeviceIconState.sensor_alarm,
    DeviceIconState.alarm,
];
